import clsx from 'clsx';
import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  hint?: ReactNode;
  error?: string;
  required?: boolean;
  compact?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, hint, error, required, compact, className, id, ...props }, ref) => {
    const inputId = id || props.name || 'input';
    const hintId = `${inputId}-hint`;

    return (
      <div
        className={clsx('tds-form-group', {
          'tds-form-group--compact': compact,
          'tds-form-group--error': error,
        })}
      >
        {label && (
          <label
            className={clsx('tds-label', {
              'tds-label--compact': compact,
            })}
            htmlFor={inputId}
          >
            {label}
            {required && <span className="tds-fieldset__required">*</span>}
          </label>
        )}

        {hint && (
          <div id={hintId} className="tds-label__hint">
            {hint}
          </div>
        )}

        {error && <div className="tds-error-message">{error}</div>}

        <input
          {...props}
          ref={ref}
          id={inputId}
          className={clsx(
            'tds-input',
            {
              'tds-input--error': error,
            },
            className,
          )}
          aria-describedby={hint ? hintId : undefined}
        />
      </div>
    );
  },
);

Input.displayName = 'Input';
